export default {
  // 页面
  'pages.tenant.list.title': '租户列表',
  'pages.tenant.list.subtitle': '管理所有租户账号、订阅状态和基本信息',
  'pages.tenant.list.searchPlaceholder': '搜索公司名称、邮箱、手机号',

  // 列标题
  'pages.tenant.list.column.id': '租户ID',
  'pages.tenant.list.column.tenantName': '租户名称',
  'pages.tenant.list.column.tenantCode': '租户编码',
  'pages.tenant.list.column.email': '邮箱',
  'pages.tenant.list.column.phone': '手机号',
  'pages.tenant.list.column.agent': '归属代理',
  'pages.tenant.list.column.industryType': '行业类型',
  'pages.tenant.list.column.storeCount': '门店数',
  'pages.tenant.list.column.deviceCount': '设备数',
  'pages.tenant.list.column.subscriptionStatus': '订阅状态',
  'pages.tenant.list.column.expireTime': '到期时间',
  'pages.tenant.list.column.createTime': '创建时间',
  'pages.tenant.list.column.operation': '操作',

  // 操作
  'pages.tenant.list.add': '新增租户',
  'pages.tenant.list.export': '导出',
  'pages.tenant.list.batchExport': '批量导出',
  'pages.tenant.list.clearSelection': '取消选择',
  'pages.tenant.list.view': '查看详情',
  'pages.tenant.list.edit': '编辑',
  'pages.tenant.list.resetPassword': '重置密码',
  'pages.tenant.list.resetPasswordConfirm': '确定重置密码吗？',
  'pages.tenant.list.resetAdminMenus': '赋满管理员权限',
  'pages.tenant.list.resetAdminMenusConfirm':
    '将把该租户管理员菜单重置为当前全部租户端菜单（覆盖原有勾选），确定吗？',
  'pages.tenant.list.updateExpireTime': '修改过期时间',

  // Card 标题
  'pages.tenant.list.card.basicInfo': '基础信息',
  'pages.tenant.list.card.accountInfo': '账号信息',
  'pages.tenant.list.card.business': '业务管理',

  // 表单-基础信息
  'pages.tenant.list.form.tenantName': '租户名称',
  'pages.tenant.list.form.tenantNamePlaceholder': '请输入租户名称',
  'pages.tenant.list.form.tenantNameRequired': '请输入租户名称',
  'pages.tenant.list.form.tenantNameMaxLen': '租户名称不能超过100个字符',
  'pages.tenant.list.form.companyName': '企业名称',
  'pages.tenant.list.form.companyNamePlaceholder': '请输入企业名称',
  'pages.tenant.list.form.agent': '归属代理',
  'pages.tenant.list.form.agentPlaceholder': '请选择归属代理',
  'pages.tenant.list.form.tenantType': '租户类型',
  'pages.tenant.list.form.tenantTypePlaceholder': '请选择租户类型',
  'pages.tenant.list.form.tenantTypeRequired': '请选择租户类型',
  'pages.tenant.list.form.region': '所在区域',
  'pages.tenant.list.form.regionPlaceholder': '请选择区域',
  'pages.tenant.list.form.regionRequired': '请选择所在区域',
  'pages.tenant.list.form.address': '详细地址',
  'pages.tenant.list.form.addressPlaceholder': '请输入详细地址',
  'pages.tenant.list.form.addressMaxLen': '详细地址不能超过255个字符',

  // 表单-账号信息
  'pages.tenant.list.form.username': '用户名',
  'pages.tenant.list.form.usernamePlaceholder': '请输入用户名',
  'pages.tenant.list.form.usernameRequired': '请输入用户名',
  'pages.tenant.list.form.usernameLength': '用户名长度需4-20字符',
  'pages.tenant.list.form.usernamePattern': '账号只能包含字母、数字、下划线',
  'pages.tenant.list.form.password': '密码',
  'pages.tenant.list.form.passwordPlaceholder': '请输入密码',
  'pages.tenant.list.form.passwordRequired': '请输入密码',
  'pages.tenant.list.form.passwordNoChinese': '密码不能包含中文字符',
  'pages.tenant.list.form.passwordNotPureNum': '密码不能为纯数字',
  'pages.tenant.list.form.email': '联系邮箱',
  'pages.tenant.list.form.emailPlaceholder': '请输入邮箱',
  'pages.tenant.list.form.emailRequired': '请输入邮箱',
  'pages.tenant.list.form.emailInvalid': '请输入正确的邮箱格式',
  'pages.tenant.list.form.contactPhone': '联系电话',
  'pages.tenant.list.form.contactPhonePlaceholder': '请输入联系电话',
  'pages.tenant.list.form.contactPhoneRequired': '请输入联系电话',
  'pages.tenant.list.form.contactPhoneInvalid':
    '请输入正确的菲律宾手机号码格式',
  'pages.tenant.list.form.adminAccount': '管理员账号',

  // 表单-业务管理
  'pages.tenant.list.form.industryType': '行业类型',
  'pages.tenant.list.form.industryTypePlaceholder': '请选择行业类型',
  'pages.tenant.list.form.industryTypeRequired': '请选择行业类型',
  'pages.tenant.list.form.packageId': '订阅套餐',
  'pages.tenant.list.form.packageIdPlaceholder': '请选择订阅套餐',
  'pages.tenant.list.form.packageIdRequired': '请选择订阅套餐',
  'pages.tenant.list.form.tenantPackage': '租户套餐',
  'pages.tenant.list.form.subscriptionStatus': '订阅状态',
  'pages.tenant.list.form.expireTime': '过期时间',

  // 续期弹窗
  'pages.tenant.list.modal.expireTimeTitle': '更改套餐时间',
  'pages.tenant.list.form.expireTimeRequired': '请选择到期时间',
  'pages.tenant.list.form.expireTimeNotBefore': '到期时间不能早于当前时间',
  'pages.tenant.list.form.reason': '原因',
  'pages.tenant.list.form.reasonPlaceholder': '请输入修改原因',
  'pages.tenant.list.form.reasonRequired': '请输入修改原因',

  // 消息
  'pages.tenant.list.message.deleteSuccess': '删除成功',
  'pages.tenant.list.message.resetPasswordSuccess': '密码重置成功',
  'pages.tenant.list.message.resetAdminMenusSuccess':
    '已赋满该租户管理员菜单权限',
  'pages.tenant.list.message.exportDev': '导出功能开发中...',
  'pages.tenant.list.message.selectAtLeastOne': '请至少选择一项',
  'pages.tenant.list.exportFileName': '租户列表',
  'pages.tenant.list.message.exportSuccess': '已导出 {count} 条租户数据',
  'pages.tenant.list.message.exportFailed': '导出失败',
  'pages.tenant.list.message.addSuccess': '新增成功',
  'pages.tenant.list.message.updateSuccess': '更新成功',
  'pages.tenant.list.message.updateExpireTimeSuccess': '修改成功',
  'pages.tenant.list.message.getDetailFailed': '获取租户详情失败',

  // 通用
  'pages.tenant.list.save': '保存',
  'pages.tenant.list.cancel': '取消',
  'pages.tenant.list.backToList': '返回至列表',
  'pages.tenant.list.page.addTitle': '新增租户',
  'pages.tenant.list.page.editTitle': '编辑租户',
};
